import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"

import { apiDelete, apiGet, apiPost, apiPut } from "./api/server"


const ProfileView = () => {

  const [tagsList, setTagsList] = useState([]);
  const [textBox, setTextBox] = useState("");
  const [successText, setSuccessText] = useState("");
  const [tagToDelete, setTagToDelete] = useState();

  useEffect(() => {
    apiGet(`intraneteventtags/getalleventtags`).then(res => {
        res.json().then(data => {
          setTagsList(data)
        })
      })
  }, [])

  function deleteTagConfirmed(){
    apiDelete(`intraneteventtags/deleteeventtag`, {tag_id: tagToDelete}).then(response => {
      if(response.ok){
        setTagToDelete(null)
        apiGet(`intraneteventtags/getalleventtags`).then(res => {
          res.json().then(data => {
            setTagsList(data)
          })
        })
      }
    })
  }

  function addTag(){
    if (textBox){
      apiPut(`intraneteventtags/addeventtag`, {tag: textBox})
      .then(response => {
        if(response.ok){
          setSuccessText("Tag Added Successfully.")
          apiGet(`intraneteventtags/getalleventtags`).then(res => {
            res.json().then(data => {
              setTagsList(data)
            })
          })
        }else{
          setSuccessText("Tag Already Exists")
        }
      })
    }
  }


  return (
    <>
    <Container>
      <Row>
          <Col>
            <h1>Event Tag Management</h1>
            <a href={`/events`} className="btn btn-primary">
                    Back
            </a>
            <Row>
              <Col>
                <Form.Control onChange={(event) => setTextBox(event.target.value)} type="text" value={textBox} />
              </Col>
              <Col>
                <Button onClick={addTag}>Add Tag</Button>
              </Col>
              <Col>
                {successText}
              </Col>
            </Row>
            
            
            <div className="section">
              {tagsList.map(tag => {
                if(!textBox || tag.tag.toLowerCase().includes(textBox.toLowerCase()))
                return <span className="tag">{tag.tag} <span onClick={() => setTagToDelete(tag.id)}>X</span></span>
              })}
            </div>
          </Col>
        </Row>
      </Container>
      <Modal  show={tagToDelete} onHide={() => setTagToDelete(null)}>
              <Modal.Header closeButton>
                <Modal.Title>Tag Deletion</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are You Sure you want to delete this tag?  This will remove the tag from all events.</Modal.Body>
              <Modal.Footer>
              <Button variant="primary" onClick={deleteTagConfirmed}>
                  Yes
                </Button>
                <Button variant="secondary" onClick={() => setTagToDelete(null)}>
                  No
                </Button>
                
              </Modal.Footer>
            </Modal>
    </>
  );
};

export default ProfileView;
